import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadMonth: -1,
    loadTime: -1,
    block: -1,
    unblock: -1,
    deleting: -1,
    create: -1,
    createPatient: -1,
  },
  timeslotMonth: [],
  timeslots: [],
  createdPatient: null,
  error: null,
};

const updateContentItem = (item, newItem) => {
  const temp = { ...item };
  temp.total += newItem.amountTotal;
  temp.booked += newItem.amountBooked;
  return temp;
};

const updateTimeslotMonth = (list, item) =>
  list.map(i => (i.day === item.day ? updateContentItem(i, item) : i));

export default function reducer(state = initialState, action) {
  const { type, payload, error, meta } = action;

  switch (type) {
    case ACTION_TYPES.TIMESLOTS_DAY_GET_REQUESTED:
      return {
        ...state,
        status: {
          loadMonth: 0,
        },
      };
    case ACTION_TYPES.TIMESLOTS_DAY_GET_SUCCEED:
      return {
        ...state,
        status: {
          loadMonth: 1,
        },
        timeslotMonth: payload.data,
      };
    case ACTION_TYPES.TIMESLOTS_DAY_GET_FAILED:
      return {
        ...state,
        status: {
          loadMonth: 2,
        },
        error,
      };
    case ACTION_TYPES.TIMESLOTS_GET_REQUESTED:
      return {
        ...state,
        status: {
          loadTime: 0,
        },
      };
    case ACTION_TYPES.TIMESLOTS_GET_SUCCEED:
      return {
        ...state,
        status: {
          loadTime: 1,
        },
        timeslots: payload.result.data,
      };
    case ACTION_TYPES.TIMESLOTS_GET_FAILED:
      return {
        ...state,
        status: {
          loadTime: 2,
        },
        error,
      };
    case ACTION_TYPES.TIMESLOT_DELETE_REQUESTED:
      return {
        ...state,
        status: {
          deleting: 0,
        },
      };
    case ACTION_TYPES.TIMESLOT_DELETE_SUCCEED: {
      const { timeslotId } = meta;
      return {
        ...state,
        status: {
          deleting: 1,
        },
        timeslots: state.timeslots.filter(item => item !== timeslotId),
      };
    }
    case ACTION_TYPES.TIMESLOT_DELETE_FAILED:
      return {
        ...state,
        status: {
          deleting: 2,
        },
        error,
      };
    case ACTION_TYPES.TIMESLOTS_DELETE_REQUESTED:
      return {
        ...state,
        status: {
          deleting: 0,
        },
      };
    case ACTION_TYPES.TIMESLOTS_DELETE_SUCCEED: {
      const { timeslotIds } = meta;
      return {
        ...state,
        status: {
          deleting: 1,
        },
        timeslots: state.timeslots.filter(item => timeslotIds.indexOf(item) === -1),
      };
    }
    case ACTION_TYPES.TIMESLOTS_DELETE_FAILED:
      return {
        ...state,
        status: {
          deleting: 2,
        },
        error,
      };
    case ACTION_TYPES.TIMESLOT_BLOCK_REQUESTED:
      return {
        ...state,
        status: {
          block: 0,
        },
      };
    case ACTION_TYPES.TIMESLOT_BLOCK_SUCCEED:
      return {
        ...state,
        status: {
          block: 1,
        },
      };
    case ACTION_TYPES.TIMESLOT_BLOCK_FAILED:
      return {
        ...state,
        status: {
          block: 2,
        },
        error,
      };
    case ACTION_TYPES.TIMESLOT_UNBLOCK_REQUESTED:
      return {
        ...state,
        status: {
          unblock: 0,
        },
      };
    case ACTION_TYPES.TIMESLOT_UNBLOCK_SUCCEED:
      return {
        ...state,
        status: {
          unblock: 1,
        },
      };
    case ACTION_TYPES.TIMESLOT_UNBLOCK_FAILED:
      return {
        ...state,
        status: {
          unblock: 2,
        },
        error,
      };

    case ACTION_TYPES.TIMESLOT_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          create: 0,
        },
      };
    case ACTION_TYPES.TIMESLOT_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          create: 1,
        },
        timeslots: [...state.timeslots, ...payload.result.data],
      };
    case ACTION_TYPES.TIMESLOT_CREATE_FAILED:
      return {
        ...state,
        status: {
          create: 2,
        },
        error,
      };

    case ACTION_TYPES.TIMESLOT_RESET:
      return {
        ...state,
        status: {
          ...state.status,
          create: -1,
        },
        timeslots: [],
      };

    case ACTION_TYPES.TIMESLOT_UPDATE_MONTH:
      return {
        ...state,
        timeslotMonth: updateTimeslotMonth(state.timeslotMonth, payload),
      };

    default:
      return state;
  }
}
